import toast from 'react-hot-toast';

export const isFormValid = (formData) => {
  if (formData.naziv === '' || formData.naziv === null) {
    toast.error('Naziv je obavezno polje.');
    return true;
  }
  if (formData.jm === '' || formData.jm === null) {
    toast.error('Jedinica mere  je obavezno polje.');
    return true;
  }
  if (formData.nazivTipa === '' || formData.nazivTipa === null) {
    toast.error('Tip  je obavezno polje.');
    return true;
  }

  return false;
};
